export const handler =
  (level: string, fn: (...data: unknown[]) => void) =>
  (...args: unknown[]) => {
    if (levels.indexOf(level) <= levels.indexOf("error")) {
      let date = new Date().toString().split("GMT")[0] + " UTC";
      date = new Date(date).toJSON().replace("T", " ").replace("Z", "");
      fn(date, level.toUpperCase(), ...args);
    }
  };

export const levels = ["off", "fatal", "error", "warn", "info", "debug", "all"];

export const methods = {
  fatal: handler("fatal", console.error),
  error: handler("error", console.error),
  warn: handler("warn", console.warn),
  info: handler("info", console.info),
  debug: handler("debug", console.debug),
  trace: handler("debug", console.trace),
};

export default methods;
